$(function () {
  $("#js-animated-counter").waypoint(
    function () {
      $("#js-animated-counter")
        .prop("Counter", 0)
        .animate(
          {
            Counter: $("#js-animated-counter").text(),
          },
          {
            duration: 3000,
            easing: "swing",
            step: function (target) {
              $("#js-animated-counter").text(
                Math.ceil(target).toLocaleString("en")
              );
            },
          }
        );
      this.destroy();
    },
    { offset: "100%" }
  );
});
